import qs from 'query-string';
import { ISbbIDLoginData } from '~/stores/authStore';

export const sbbLoginDataCollection = (): ISbbIDLoginData => {
  const { code, state } = qs.parse(
    location.search
  ) as {
    code: string;
    state: string;
  };
  const { origin, pathname } = location;

  return {
    state: typeof state !== 'undefined' ? state : '',
    code: typeof code !== 'undefined' ? code : '',
    location: `${origin}${pathname}`,
  };
};
